module.exports = __webpack_public_path__ + "static/img/news_xiangqing_tu2.34fbdda.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_xiangqing_tu2.png
// module id = nT+p
// module chunks = 0